import { useState } from 'react'

// ── Configuration ─────────────────────────────────────────────────────────────
// Update this URL to your Ko-fi membership tiers page.
const KOFI_TIERS_URL = 'https://ko-fi.com/onceuponastream/tiers'

// ── Wall of Honor ─────────────────────────────────────────────────────────────
// Add founding member names here — one string per entry.
// They render permanently on the Founding Members screen.
const FOUNDING_MEMBERS = [
  'mindabean04',
  // '',
  // 'Early Supporter',
]

// ── Founding Members Modal ────────────────────────────────────────────────────
function FoundingMembersModal({ onClose, bgMode }) {
  const dark = bgMode === 'dark'

  return (
    <div
      onClick={e => { if (e.target === e.currentTarget) onClose() }}
      style={{
        position: 'fixed', inset: 0, zIndex: 900,
        background: 'rgba(0,0,0,0.74)', backdropFilter: 'blur(8px)',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'flex-end',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      <div style={{
        width: '100%', maxWidth: 520,
        background: dark ? '#040e07' : '#f4faf6',
        border: dark
          ? '1.5px solid rgba(251,191,36,0.2)'
          : '1.5px solid rgba(217,119,6,0.22)',
        borderRadius: '22px 22px 0 0',
        padding: '24px 22px 40px',
        maxHeight: '80vh',
        display: 'flex', flexDirection: 'column',
      }}>
        {/* Drag handle */}
        <div style={{
          width: 38, height: 4, borderRadius: 2,
          background: 'rgba(150,150,150,0.3)',
          margin: '0 auto 22px',
        }} />

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: 22 }}>
          <div style={{ fontSize: 38, marginBottom: 10 }}>🏆</div>
          <div style={{
            fontFamily: "'DM Serif Display', Georgia, serif",
            fontStyle: 'italic', fontSize: 22, fontWeight: 400,
            color: dark ? '#fde68a' : '#92400e',
            lineHeight: 1.2, marginBottom: 6,
          }}>
            Founding Members
          </div>
          <div style={{
            fontSize: 12,
            color: dark ? 'rgba(180,215,235,0.55)' : 'rgba(30,50,40,0.5)',
          }}>
            The people who believed first.
          </div>
        </div>

        {/* Divider */}
        <div style={{
          height: 1, margin: '0 0 20px',
          background: dark
            ? 'rgba(251,191,36,0.12)'
            : 'rgba(217,119,6,0.14)',
        }} />

        {/* Names list */}
        <div style={{ overflowY: 'auto', flex: 1 }}>
          {FOUNDING_MEMBERS.length === 0 ? (
            <div style={{
              textAlign: 'center', padding: '36px 16px',
              fontSize: 13, lineHeight: 1.7,
              color: dark ? 'rgba(180,215,235,0.35)' : 'rgba(30,50,40,0.35)',
              fontStyle: 'italic',
            }}>
              Names of founding supporters<br />will appear here permanently.
            </div>
          ) : (
            FOUNDING_MEMBERS.map((name, i) => (
              <div
                key={i}
                style={{
                  display: 'flex', alignItems: 'center', gap: 12,
                  padding: '13px 4px',
                  borderBottom: i < FOUNDING_MEMBERS.length - 1
                    ? (dark
                      ? '1px solid rgba(251,191,36,0.07)'
                      : '1px solid rgba(217,119,6,0.09)')
                    : 'none',
                }}
              >
                <span style={{
                  fontSize: 13,
                  color: dark ? 'rgba(253,230,138,0.45)' : 'rgba(180,100,0,0.45)',
                }}>
                  ✦
                </span>
                <span style={{
                  fontSize: 16, fontWeight: 600,
                  fontFamily: "'DM Serif Display', Georgia, serif",
                  color: dark ? 'rgba(220,238,248,0.9)' : '#1e2922',
                }}>
                  {name}
                </span>
              </div>
            ))
          )}
        </div>

        {/* Close button */}
        <button
          onClick={onClose}
          style={{
            marginTop: 20, width: '100%', padding: '12px 0',
            borderRadius: 12, fontSize: 13, fontWeight: 700,
            fontFamily: 'inherit', background: 'transparent',
            border: dark
              ? '1.5px solid rgba(251,191,36,0.2)'
              : '1.5px solid rgba(217,119,6,0.22)',
            color: dark ? 'rgba(253,230,138,0.65)' : '#92400e',
            cursor: 'pointer', WebkitTapHighlightColor: 'transparent',
          }}
        >
          Close
        </button>
      </div>
    </div>
  )
}

// ── Founder's Club Panel ──────────────────────────────────────────────────────
export default function SettingsFoundersClub({ bgMode }) {
  const [showMembers, setShowMembers] = useState(false)
  const [launching, setLaunching]     = useState(false)
  const dark = bgMode === 'dark'

  // Visual feedback only — navigation is handled by the <a href> tag
  const handleLaunch = () => {
    if (launching) return
    setLaunching(true)
    setTimeout(() => setLaunching(false), 2000)
  }

  return (
    <>
      <div style={{
        borderRadius: 16, padding: 18, marginBottom: 16,
        backdropFilter: 'blur(12px)',
        background: dark
          ? 'linear-gradient(135deg,rgba(28,14,2,0.96),rgba(18,8,0,0.92))'
          : 'linear-gradient(135deg,rgba(255,248,232,0.97),rgba(255,238,205,0.93))',
        border: dark
          ? '1.5px solid rgba(251,191,36,0.35)'
          : '1.5px solid rgba(217,119,6,0.4)',
        boxShadow: dark
          ? '0 0 36px rgba(251,191,36,0.07), inset 0 1px 0 rgba(251,191,36,0.07)'
          : '0 4px 24px rgba(217,119,6,0.09)',
      }}>

        {/* Label */}
        <div style={{
          fontSize: 10, fontWeight: 700, letterSpacing: '0.1em',
          textTransform: 'uppercase', marginBottom: 10,
          color: dark ? 'rgba(253,230,138,0.45)' : 'rgba(180,100,0,0.5)',
        }}>
          Limited Offer
        </div>

        {/* Icon + title row */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
          <span style={{ fontSize: 26, lineHeight: 1 }}>🌟</span>
          <div>
            <div style={{
              fontSize: 16, fontWeight: 800, lineHeight: 1.2,
              color: dark ? '#fde68a' : '#92400e',
            }}>
              Join the Founder's Club
            </div>
            <div style={{
              fontSize: 11, marginTop: 2,
              color: dark ? 'rgba(253,230,138,0.52)' : 'rgba(180,100,0,0.58)',
            }}>
              Exclusive badge · Wall of Honor · Early influence
            </div>
          </div>
        </div>

        {/* Description */}
        <div style={{
          fontSize: 12, lineHeight: 1.7, marginBottom: 16,
          color: dark ? 'rgba(253,230,138,0.62)' : 'rgba(130,70,0,0.68)',
        }}>
          Be among the first to shape Flow. Founding members get a permanent badge,
          their name on the Wall of Honor, and a direct line to influence what we
          build next.
        </div>

        {/* Primary CTA — native <a> for reliable mobile navigation */}
        <a
          href={KOFI_TIERS_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleLaunch}
          style={{
            display: 'block', width: '100%', boxSizing: 'border-box',
            textAlign: 'center', textDecoration: 'none',
            padding: '13px 0', borderRadius: 12,
            fontSize: 13, fontWeight: 700, fontFamily: 'inherit',
            cursor: launching ? 'default' : 'pointer',
            background: launching
              ? (dark
                ? 'linear-gradient(135deg,rgba(251,191,36,0.3),rgba(217,119,6,0.22))'
                : 'linear-gradient(135deg,rgba(251,191,36,0.38),rgba(217,119,6,0.28))')
              : (dark
                ? 'linear-gradient(135deg,rgba(251,191,36,0.2),rgba(217,119,6,0.13))'
                : 'linear-gradient(135deg,rgba(251,191,36,0.3),rgba(217,119,6,0.2))'),
            border: launching
              ? (dark ? '1.5px solid rgba(251,191,36,0.65)' : '1.5px solid rgba(217,119,6,0.65)')
              : (dark ? '1.5px solid rgba(251,191,36,0.38)' : '1.5px solid rgba(217,119,6,0.48)'),
            color: dark ? (launching ? '#fef3c7' : '#fde68a') : '#92400e',
            transform: launching ? 'scale(0.982)' : 'scale(1)',
            transition: 'all 0.22s cubic-bezier(0.16,1,0.3,1)',
            WebkitTapHighlightColor: 'transparent',
            letterSpacing: '0.01em',
          }}
        >
          {launching ? '✦ Opening…' : '🚀 Unlock Founder\'s Badge & Premium'}
        </a>

        {/* Wall of Honor trigger */}
        <button
          onClick={() => setShowMembers(true)}
          style={{
            display: 'block', width: '100%', marginTop: 11,
            background: 'none', border: 'none', padding: '5px 0',
            fontSize: 11, fontWeight: 600, fontFamily: 'inherit',
            cursor: 'pointer', textAlign: 'center', letterSpacing: '0.03em',
            color: dark ? 'rgba(253,230,138,0.38)' : 'rgba(180,100,0,0.42)',
            WebkitTapHighlightColor: 'transparent',
          }}
        >
          🏆 View Founding Members
        </button>
      </div>

      {showMembers && (
        <FoundingMembersModal
          bgMode={bgMode}
          onClose={() => setShowMembers(false)}
        />
      )}
    </>
  )
}
